import { createI18n } from 'vue-i18n'

import de from './locales/de.json'
import en from './locales/en.json'
import pl from './locales/pl.json'

const numberFormats = {
  en: {
    currency: {
      style: 'currency', currency: 'USD', notation: 'standard'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 2
    },
    decimal1: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  de: {
    currency: {
      style: 'currency', currency: 'EUR', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 2
    },
    decimal1: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  pl: {
    currency: {
      style: 'currency', currency: 'EUR', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 2
    },
    decimal1: {
      style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
}

const datetimeFormats = {
  de: {
    time: {
      hour: '2-digit', minute: '2-digit'
    },
    short: {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    },
    custom: {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }
  },  
  en: {
    short: {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  pl: {
    time: {
      hour: '2-digit', minute: '2-digit'
    },
    short: {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    },
    custom: {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }
  }
}

function loadLocaleMessages() {
  return {
    de,
    en,
    pl,
  };
}

const userLocale = (navigator.language || "de").split("-")[0];

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: userLocale,
  fallbackLocale: "en",
  messages: loadLocaleMessages(),

  numberFormats,
  datetimeFormats,

  // optional: sauberer Debug statt Console-Spam
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
});